export default "__VITE_ASSET__Ddb1F9wW__"